import type { Candidate, Participant, ResponseRow } from '../types'
import type { BookingMap } from '../api'
import Grid from '../components/Grid'
import MyGrid, { type MyGridEvent, type MyGridRow } from '../components/MyGrid'
import { btnPrimary } from '../lib/ui'

// ── サンプルデータ（DBには一切書き込まない・固定表示）──
const candidates: Candidate[] = [
  { id: 'c1', label: '6/20(土) 19:00〜', date: '2026-06-20', sort_order: 0 },
  { id: 'c2', label: '6/21(日) 19:00〜', date: '2026-06-21', sort_order: 1 },
  { id: 'c3', label: '6/27(土) 19:00〜', date: '2026-06-27', sort_order: 2 },
]
const participants: Participant[] = [
  { id: 'p1', name: 'あおい', comment: '20日がいいな', created_at: 1 },
  { id: 'p2', name: 'ひかる', comment: null, created_at: 2 },
  { id: 'p3', name: 'かえで', comment: null, created_at: 3 },
  { id: 'p4', name: 'あなた', comment: null, created_at: 4 },
]
const responses: ResponseRow[] = [
  { participant_id: 'p1', candidate_id: 'c1', mark: 'ok' },
  { participant_id: 'p1', candidate_id: 'c2', mark: 'maybe' },
  { participant_id: 'p1', candidate_id: 'c3', mark: 'ok' },
  { participant_id: 'p2', candidate_id: 'c1', mark: 'ok' },
  { participant_id: 'p2', candidate_id: 'c2', mark: 'no' },
  { participant_id: 'p2', candidate_id: 'c3', mark: 'ok' },
  { participant_id: 'p3', candidate_id: 'c1', mark: 'maybe' },
  { participant_id: 'p3', candidate_id: 'c2', mark: 'ok' },
  { participant_id: 'p3', candidate_id: 'c3', mark: 'ok' },
  { participant_id: 'p4', candidate_id: 'c1', mark: 'ok' },
  { participant_id: 'p4', candidate_id: 'c2', mark: 'maybe' },
  { participant_id: 'p4', candidate_id: 'c3', mark: 'maybe' },
]

const myEvents: MyGridEvent[] = [
  { id: 'a', title: 'チーム飲み会' },
  { id: 'b', title: 'サークル合宿' },
]
const myRows: MyGridRow[] = [
  { date: '2026-06-20', cells: { a: 'ok', b: 'ok' } },
  { date: '2026-06-21', cells: { a: 'maybe' } },
  { date: '2026-06-27', cells: { a: 'maybe' } },
  { date: '2026-06-28', cells: { b: 'maybe' } },
]

// ── ②「ハマる例」用：複数人×複数予定でブッキング色が効く見本 ──
const bCands: Candidate[] = [
  { id: 'd1', label: '7/3(金) 19:00〜', date: '2026-07-03', sort_order: 0 },
  { id: 'd2', label: '7/4(土) 18:00〜', date: '2026-07-04', sort_order: 1 },
  { id: 'd3', label: '7/8(水) 19:00〜', date: '2026-07-08', sort_order: 2 },
]
const bParts: Participant[] = [
  { id: 'q1', name: 'ひかる', comment: null, created_at: 1 },
  { id: 'q2', name: 'かえで', comment: null, created_at: 2 },
  { id: 'q3', name: 'そら', comment: null, created_at: 3 },
  { id: 'q4', name: 'あおい', comment: null, created_at: 4 },
]
const bResp: ResponseRow[] = [
  { participant_id: 'q4', candidate_id: 'd1', mark: 'ok' },
  { participant_id: 'q2', candidate_id: 'd1', mark: 'ok' },
  { participant_id: 'q3', candidate_id: 'd1', mark: 'ok' },
  { participant_id: 'q1', candidate_id: 'd2', mark: 'ok' },
  { participant_id: 'q2', candidate_id: 'd2', mark: 'ok' },
  { participant_id: 'q3', candidate_id: 'd2', mark: 'ok' },
  { participant_id: 'q4', candidate_id: 'd3', mark: 'ok' },
  { participant_id: 'q2', candidate_id: 'd3', mark: 'ok' },
]
const bMap: BookingMap = {
  d2: {
    q1: { confidence: 0.19, overlapCount: 2, concern: 0.81, leadingness: 1 },
    q3: { confidence: 0.19, overlapCount: 2, concern: 0.27, leadingness: 1 },
    q2: { confidence: 0.19, overlapCount: 2, concern: 0, leadingness: 1 },
  },
}

const noop = () => {}

export default function Demo() {
  return (
    <div className="animate-in mx-auto max-w-4xl px-4 pb-16 pt-5">
      <div className="mb-3 flex items-center justify-between text-sm">
        <a href="/about" className="font-medium text-muted transition hover:text-brand">
          ← 使い方
        </a>
        <a href="/" className="font-medium text-brand transition hover:text-brand-ink">
          自分でつくる
        </a>
      </div>

      <h1 className="font-display text-2xl font-bold tracking-tight text-ink">デモ</h1>
      <div className="mb-6 mt-2 rounded-xl border border-maybe/25 bg-[#fdf6e9] px-4 py-2.5 text-sm text-[#9a7320]">
        これは見本です。<b>保存・共有はされず</b>、あなたのデータも汚しません。
      </div>

      <section className="mb-10">
        <h2 className="mb-1 font-display text-lg font-bold text-ink">① イベントの集計表</h2>
        <p className="mb-3 text-sm text-muted">
          日程×参加者で出欠が一目瞭然。○が多い最有力日には ★ が付きます。
        </p>
        <div className="mb-2 font-display text-lg font-bold text-ink">🍻 チーム飲み会</div>
        <Grid
          candidates={candidates}
          participants={participants}
          responses={responses}
          onEdit={noop}
          onDelete={noop}
        />
      </section>

      <section className="mb-10">
        <h2 className="mb-1 font-display text-lg font-bold text-ink">② 予定のかぶりを色で（ここがハマりどころ）</h2>
        <p className="mb-3 text-sm text-muted">
          同じ人が「別の予定にも○」していると、その○を色で警告します。下の <b className="text-ink">7/4</b> はみんな○に見えますが——
        </p>
        <ul className="mb-3 ml-4 list-disc space-y-1 text-sm text-muted">
          <li>
            <b className="text-ink">ひかる</b> は7/4しか空いていないのに別の予定とかぶり →{' '}
            <b className="text-ink">濃い色＋81%</b>（他へ流れるかも）
          </li>
          <li>
            <b className="text-ink">かえで</b> は全候補日に○＝動けるので <b className="text-ink">無色</b>
          </li>
        </ul>
        <div className="mb-2 font-display text-lg font-bold text-ink">🍻 同窓会</div>
        <Grid
          candidates={bCands}
          participants={bParts}
          responses={bResp}
          bookings={bMap}
          onEdit={noop}
          onDelete={noop}
        />
        <p className="mt-2 text-xs text-muted">
          複数人×複数予定が重なるほど、「本当に来そうな日」が浮かび上がります。
        </p>
      </section>

      <section className="mb-10">
        <h2 className="mb-1 font-display text-lg font-bold text-ink">③ マイ予定（横断ビュー）</h2>
        <p className="mb-3 text-sm text-muted">
          この端末で開いた複数イベントでの、自分の回答をまとめて確認できます。どの日にどのイベントで参加・未定なのかがひと目で分かります。
        </p>
        <MyGrid events={myEvents} rows={myRows} />
      </section>

      <div className="flex gap-3">
        <a href="/" className={`${btnPrimary} px-6 py-2.5`}>
          自分のイベントをつくる
        </a>
        <a
          href="/about"
          className="inline-flex items-center justify-center rounded-xl border border-line bg-white px-6 py-2.5 font-medium text-muted transition hover:border-brand/40 hover:text-brand-ink"
        >
          使い方に戻る
        </a>
      </div>
    </div>
  )
}
